module.exports = __webpack_public_path__ + "img/hu.90054d36.jpg";